import { render } from "./MainDisbursements.vue?vue&type=template&id=53d39d48&scoped=true"
import script from "./MainDisbursements.vue?vue&type=script&lang=js"
export * from "./MainDisbursements.vue?vue&type=script&lang=js"

import "./MainDisbursements.vue?vue&type=style&index=0&id=53d39d48&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d39d48"]])

export default __exports__